(function () {
  function initFilterBanner(banner) {
    var toggleGroups = banner.querySelectorAll('[data-sofa-type-group], [data-color-group]');

    toggleGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var button = e.target.closest('button');
        if (!button || !group.contains(button)) return;

        var alreadySelected = button.classList.contains('is-selected');
        group.querySelectorAll('button').forEach(function (btn) {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
        });

        if (!alreadySelected) {
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
        }
      });
    });

    var findCoverBtn = banner.querySelector('[data-find-cover]');
    if (!findCoverBtn) return;

    findCoverBtn.addEventListener('click', function (e) {
      e.preventDefault();

      var baseUrl = findCoverBtn.getAttribute('href');
      var params = new URLSearchParams();
      var selectedButtons = [
        banner.querySelector('[data-sofa-type-group] button.is-selected'),
        banner.querySelector('[data-color-group] button.is-selected')
      ];

      selectedButtons.forEach(function (btn) {
        if (!btn) return;
        var filterUrl = btn.getAttribute('data-filter-url') || '';
        var query = filterUrl.split('?')[1];
        if (!query) return;
        new URLSearchParams(query).forEach(function (value, key) {
          params.append(key, value);
        });
      });

      var queryString = params.toString();
      window.location.href = queryString ? baseUrl + '?' + queryString : baseUrl;
    });
  }

  document.querySelectorAll('.m-product-tabs__banner').forEach(initFilterBanner);
})();